import { Box, Card, type SxProps, type Theme, Typography } from '@mui/material'
import { type ReactNode } from 'react'

export const SimpleImageCard = ({
  imageSource,
  sx,
  fallbackContent,
}: {
  imageSource: string | undefined | null
  sx?: SxProps<Theme>
  fallbackContent?: ReactNode
}) => {
  const shouldShowFallback = imageSource === null || imageSource === undefined

  return (
    <Card sx={sx}>
      {imageSource && (
        <img
          alt="ImageCard"
          src={imageSource}
          className="w-full h-full object-center object-cover"
        />
      )}
      {shouldShowFallback && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 120,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {fallbackContent ?? <Typography>No image</Typography>}
        </Box>
      )}
    </Card>
  )
}
